import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'mg-mm-districts',
  templateUrl: './mm-districts.component.html',
  styleUrls: ['./mm-districts.component.scss'],
})
export class MmDistrictsComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
